import { render, staticRenderFns } from "./finance-config.vue?vue&type=template&id=0f865fa4&scoped=true&"
import script from "./finance-config.vue?vue&type=script&lang=js&"
export * from "./finance-config.vue?vue&type=script&lang=js&"
import style0 from "./finance-config.vue?vue&type=style&index=0&id=0f865fa4&lang=scss&scoped=true&"
import style1 from "./finance-config.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f865fa4",
  null
  
)

export default component.exports